import ManageVideos from './ManageVideos';

export default ManageVideos;
